import { createStore } from "vuex";
import authModel from "./modules/auth";
import racesModel from "./modules/races";
import spellsModel from "./modules/spells";
import combatModel from "./modules/combat";
import charactersModel from "./modules/characters";
import campaignArtefactsModel from "./modules/campaignArtefacts";

console.log("HERE IndexJS");

const store = createStore({
  modules: {
    auth: authModel,
    races: racesModel,
    spells: spellsModel,
    combat: combatModel,
    characters: charactersModel,
    campaignArtefacts: campaignArtefactsModel,
  },
});

export default store;
